<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">

                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                        <!-- <img src="/img/noimage.png" class="rounded-circle"> -->
                                        <img style="max-width:250px" v-if="form.photo === ''" src="/img/noimage.png">
                                        <img style="max-width:250px" v-if="form.photo !== ''" :src="form.photo.thumbnail">
                                </div>
                            </div>
                        </div>
                        <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                            <div class="d-flex justify-content-between">
                                <!-- <base-button size="sm" type="info" class="mr-4">Connect</base-button>
                                <base-button size="sm" type="default" class="float-right">Message</base-button> -->
                            </div>
                        </div>
                        <div class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center mt-md-5" style="margin-bottom:50px">
                                        <!-- <div>
                                            <span class="heading">22</span>
                                            <span class="description">Friends</span>
                                        </div>
                                        <div>
                                            <span class="heading">10</span>
                                            <span class="description">Photos</span>
                                        </div>
                                        <div>
                                            <span class="heading">89</span>
                                            <span class="description">Comments</span>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <div style="margin-bottom:50px">
                                    <base-button @click="Delete('ImgMember')" v-if="form.photo !== ''" type="danger">{{$t('delete_image')}}</base-button><br /><br />
                                    <div class="custom-file">
                                        <input type="file" accept="image/*" name="member_img" id="member_img" ref="member_img" v-on:change="onFileChanged()" class="custom-file-input">
                                        <label class="custom-file-label" for="member_img">{{$t('change_image')}}</label>
                                    </div>
                                </div>
                                <h3>
                                    {{$t('status')}} : 
                                    <span v-if="form.status === 'new'" class="font-weight-light">{{$t('new')}}</span>
                                    <span v-if="form.status === 'active'" class="font-weight-light">{{$t('active')}}</span>
                                    <span v-if="form.status === 'disabled'" class="font-weight-light">{{$t('disabled')}}</span>
                                    <span v-if="form.status === 'expired'" class="font-weight-light">{{$t('expired')}}</span>
                                </h3>
                                <!-- <div class="h5 font-weight-300">
                                    <i class="ni location_pin mr-2"></i>Bucharest, Romania
                                </div> -->
                                <div class="h5 mt-4">
                                    {{$t('createdAt')}} : {{ form.created_at | luxon }} <br />
                                    {{$t('expired_at')}} : {{ form.expired_at | luxon }} <br />
                                    <base-button v-if="form.status === 'active'" style="margin:5px" type="warning" @click="adjustDate()">{{$t('member_adjustdate')}}</base-button> <br /><br />
                                </div>
                                <div>
                                    <base-button v-if="form.status === 'active'" style="margin:5px" type="primary" @click="CheckIn()">{{$t('checkin')}}</base-button>
                                    <router-link :to="'/'+$i18n.locale+'/member_payment?id='+id" class="text-light">
                                        <base-button style="margin:5px" type="primary">{{$t('member_payment')}}</base-button>
                                    </router-link>
                                    <router-link :to="'/'+$i18n.locale+'/history?id='+id" class="text-light">
                                        <base-button style="margin:5px" type="info">{{$t('history')}}</base-button>
                                    </router-link>
                                </div>
                                <hr class="my-4" />
                                <div v-if="passcode">
                                    {{$t('passcode')}} : {{passcode}} <br /><br />
                                </div>
                                <div>
                                    <base-button type="primary" @click="GetPasscode()">{{$t('create_passcode')}}</base-button>
                                </div>
                                <hr class="my-4" />
                                <div>
                                    <base-button @click="Delete('Member')" type="danger">{{$t('delete_member')}}</base-button>
                                </div>
                                <!-- <hr class="my-4" />
                                <p>Ryan — the name taken by Melbourne-raised, Brooklyn-based Nick Murphy — writes, performs and records all of his own music.</p>
                                <a href="#">Show more</a> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-8 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">{{$t('edit_member')}}</h3>
                                </div>
                                <div class="col-4 text-right">
                                    <!-- <a href="#!" class="btn btn-sm btn-primary">Settings</a> -->
                                </div>
                            </div>
                        </div>
                        <template>
                            <ValidationObserver v-slot="{ passes }">
                            <form @submit.prevent="passes(onSubmit)">
                                <h6 class="heading-small text-muted mb-4">{{$t('user_information')}}</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input :name="$t('first_name')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('first_name')"
                                                        rules="required"
                                                        :placeholder="$t('first_name')"
                                                        v-model="form.firstname">
                                            </base-input>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input :name="$t('last_name')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('last_name')"
                                                        rules="required"
                                                        :placeholder="$t('last_name')"
                                                        v-model="form.lastname">
                                            </base-input>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input :name="$t('phone')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('phone')"
                                                        rules="required|min:9"
                                                        :placeholder="$t('phone')"
                                                        v-model="form.phone">
                                            </base-input>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input :name="$t('email')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('email')"
                                                        rules="required|email"
                                                        :placeholder="$t('email')"
                                                        v-model="form.email">
                                            </base-input>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input :name="$t('nickname')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('nickname')"
                                                        rules="required"
                                                        :placeholder="$t('nickname')"
                                                        v-model="form.nickname">
                                            </base-input>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input :name="$t('id_card')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('id_card')"
                                                        rules="required"
                                                        :placeholder="$t('id_card')"
                                                        v-model="form.id_card">
                                            </base-input>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">

                                            {{$t('gender')}} <span style="color:red">*</span><br /><br />

                                            <base-radio name="male" class="mb-3" v-model="form.gender">
                                                {{$t('male')}}
                                            </base-radio>

                                            <base-radio name="female" class="mb-3" v-model="form.gender">
                                                {{$t('female')}}
                                            </base-radio>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">{{$t('contact_information')}}</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <base-input :name="$t('address')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('address')"
                                                        rules="required|min:4"
                                                        :placeholder="$t('address')"
                                                        v-model="form.address">
                                            </base-input>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <div class="text-right">
                                    <base-button nativeType="submit" type="primary" class="my-4">{{$t('save')}}</base-button>
                                </div>
                            </form>
                        </ValidationObserver>
                        </template>
                    </card>
                </div>
            </div>
        </div>

        <modal :show.sync="modal_adjust">

            <p>{{$t('member_adjustdate')}}</p>

            <div class="row align-items-center">
                <div class="col-lg-6" style="margin-top:20px;margin-bottom:20px">
                    <span>{{$t('createdAt')}}</span> <base-input style="padding-top: 1rem;margin-bottom: 0rem;" addon-left-icon="ni ni-calendar-grid-58">
                        <flat-picker slot-scope="{focus, blur}"
                                    @on-close="blur"
                                    :config="config"
                                    class="form-control datepicker"
                                    v-model="form.created_at">
                        </flat-picker>
                    </base-input>
                </div>
                <div class="col-lg-6" style="margin-top:20px;margin-bottom:20px">
                    <span>{{$t('expired_at')}}</span> <base-input style="padding-top: 1rem;margin-bottom: 0rem;" addon-left-icon="ni ni-calendar-grid-58">
                        <flat-picker slot-scope="{focus, blur}"
                                    @on-close="blur"
                                    :config="config"
                                    class="form-control datepicker"
                                    v-model="form.expired_at">
                        </flat-picker>
                    </base-input>
                </div>
             </div>

            <template slot="footer">
                <base-button @click="adjustDateSubmit()" type="warning">{{$t('save')}}</base-button>
                <base-button @click="modal_adjust = false" type="primary">{{$t('cancel')}}</base-button>
            </template>

        </modal>

        <modal :show.sync="modal_confirm">

            <p>{{$t('confirm_delete')}}</p>

            <template slot="footer">
                <base-button @click="modal_confirm = false" type="primary">{{$t('cancel')}}</base-button>
                <base-button v-if="type_delete === 'Member'" @click="DeleteMember(form._id)" type="danger">{{$t('delete')}}</base-button>
                <base-button v-if="type_delete === 'ImgMember'" @click="DeleteImgMember(form._id)" type="danger">{{$t('delete')}}</base-button>
            </template>

        </modal>

        <modal :show.sync="modal_success">

            <p>{{$t('confirm_success')}}</p>

            <template slot="footer">
                <base-button @click="modal_success = false" type="primary">{{$t('close')}}</base-button>
            </template>

        </modal>

        <modal :show.sync="modal"
                :gradient="modal_setting.gradient"
                modal-classes="modal-danger modal-dialog-centered">
                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4"></h4>
                    <p>{{modal_setting.alert_text}}</p>
                </div>

                <template slot="footer">
                    <base-button type="link"
                                text-color="white"
                                class="ml-auto"
                                @click="modal = false">
                        {{$t('close')}}
                    </base-button>
                </template>
            </modal>
    </div>
</template>
<script>
import { ValidationObserver } from "vee-validate"
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import i18n from "@/i18n"
  export default {
    name: 'editmember',
    components: {
        ValidationObserver,
        flatPicker
    },
    data() {
      return {
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        modal_confirm: false,
        modal_success: false,
        modal_adjust: false,
        type_delete: '',
        member_img_file: '',
        id: this.$route.query.id,
        passcode: '',
        form: {
          phone: '',
          email: '',
          firstname: '',
          lastname: '',
          nickname: '',
          id_card: '',
          address: '',
          gender: '',
          photo: ''
        },
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'j M, Y',
          altInput: true,
          dateFormat: 'Y-m-d'
        }
      }
    },
    created () {
      this.ListItem()
    },
    methods: {
        modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
        },
        Delete (type) {
            this.modal_confirm = true
            this.type_delete = type
        },
        onFileChanged () {
            this.member_img_file = this.$refs.member_img.files[0]
            this.submitFile()
        },
        submitFile () {
            let formData = new FormData()
            formData.append('file', this.member_img_file)
            this.$http.post('members/'+this.id+'/photo',
            formData)
            .then(request => this.AddImageSuccessful(request))
            .catch()
        },
        AddImageSuccessful () {
            this.ListItem()
        },
        GetPasscode () {
            this.$http.post('members/'+this.id+'/passcode')
            .then(request => this.GetPasscodeSuccessful(request))
            .catch(() => this.GetPasscodeFailed())
        },
        GetPasscodeSuccessful (req) {
            if (req.data.code !== '0') {
                this.GetPasscodeFailed(req)
                return
            }
            // alert(req.data.data.passcode)
            this.passcode = req.data.data.passcode
        },
        GetPasscodeFailed (req) {
            this.modalAlert(req)
        },
        ListItem () {
            this.$http.get('members/'+this.id)
            .then(request => this.ListItemSuccessful(request))
            .catch(() => this.ListItemFailed())
        },
        ListItemSuccessful (req) {
            if (req.data.code !== '0') {
                this.ListItemFailed(req)
                return
            }
            this.form = req.data.data
            if(req.data.data.photo === undefined) {
                this.form.photo = ''
            }
        },
        ListItemFailed (req) {
            this.modalAlert(req)
        },
        adjustDateSubmit () {
            this.$http.patch('members/'+this.id+'/adjustDate', {
                "start_at": this.form.created_at,
                "expired_at": this.form.expired_at
            })
                .then(request => this.adjustDateSubmitSuccessful(request))
                .catch(() => this.adjustDateSubmitFailed())
        },
        adjustDateSubmitSuccessful (req) {
            if (req.data.code !== '0') {
                this.adjustDateSubmitFailed(req)
                return
            }
            this.modal_adjust = false
        },
        adjustDateSubmitFailed (req) {
            this.modalAlert(req)
        },
        onSubmit () {
            this.$http.patch('members/'+this.id, {
                "email": this.form.email,
                "phone": this.form.phone,
                "firstname": this.form.firstname,
                "lastname": this.form.lastname,
                "nickname": this.form.nickname,
                "id_card": this.form.id_card,
                "address": this.form.address,
                "gender": this.form.gender
            })
                .then(request => this.onSubmitSuccessful(request))
                .catch(() => this.onSubmitFailed())
        },
        onSubmitSuccessful (req) {
            if (req.data.code !== '0') {
                this.onSubmitFailed(req)
                return
            }
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/member')
        },
        onSubmitFailed (req) {
            this.modalAlert(req)
        },
        CheckIn () {
            this.$http.post('members/'+this.id+'/checkin', {
                "channel": 'gym'
            })
                .then(request => this.CheckInSuccessful(request))
                .catch(() => this.CheckInFailed())
        },
        CheckInSuccessful (req) {
            if (req.data.code !== '0') {
                this.CheckInFailed(req)
                return
            }
            this.modal_success = true
            // this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/checkin')
        },
        CheckInFailed (req) {
            this.modalAlert(req)
        },
        GoCheckIn () {
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/checkin')
        },
        DeleteMember (id) {
            this.modal_confirm = false
            this.$http.delete('members/'+id)
            .then(request => this.DeleteMemberSuccessful(request))
            .catch(() => this.DeleteMemberFailed())
        },
        DeleteMemberSuccessful (req) {
            if (req.data.code !== '0') {
            this.DeleteMemberFailed(req)
            return
            }
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/member')
        },
        DeleteMemberFailed (req) {
            this.modalAlert(req)
        },
        DeleteImgMember (id) {
            this.modal_confirm = false
            this.$http.delete('members/'+id+'/photo')
            .then(request => this.DeleteImgMemberSuccessful(request))
            .catch(() => this.DeleteImgMemberFailed())
        },
        DeleteImgMemberSuccessful (req) {
            if (req.data.code !== '0') {
            this.DeleteImgMemberFailed(req)
            return
            }
            this.form.photo = ''
        },
        DeleteImgMemberFailed (req) {
            this.modalAlert(req)
        },
        adjustDate () {
            this.modal_adjust = true
        }
    }
  };
</script>
<style></style>
